<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex";
import Pagination from "../../../components/pagination.vue";
import formatter from "../../../mixins/formatter"
import Swal from "sweetalert2";

export default {
    page: {
        title: "Dashboard",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Pagination
    },
    mixins: [formatter],
    data() {
        return {
            title: "Dashboard",
            totalWingBand: null,
            showModal: false,
            edit_modal: false,
            loading: true,
            isLoading: false,
            isImporting: false,
            dashboardStats: {
                total_banded: 0,
                total_chapters: 0,
                total_farms: 0,
                total_stag_registry: 0,
                total_breeders: 0,
                total_admin_users: 0,
                total_encoder_users: 0,
                total_viewer_users: 0,
            },
            seasonChartData: [],
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            wingband_data: "",
            edit_data: {
                stag_registry: "",
                breeder_name: "",
                comb_shape: "",
                created_by: "",
                farm_address: "",
                farm_name: "",
                feather_color: "",
                feet_markings: "",
                leg_color: "",
                nose_markings: "",
                province: "",
                season_name: "",
                wingband_date: "",
                wingband_number: "",
                status: "",
            },
            errorMessage: "",
            filter: {
                search: "",
                limit: 10,
            },
            selectedFile: null,
            importModal: false,
            importErrors: [],
        };
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
        ...mapGetters("seasonColors", { seasonColors: "colors" }),
    },
    methods: {
        ...mapActions("wingband", {
            getList: "getList",
            importFile: "importWingband",
            archive: "update",
        }),
        ...mapActions("seasons", {
            getSeasonCount: "getStatistics",
        }),
        ...mapActions("adminDashboard", {
            getDashboardStats: "getStats",
        }),

        convertToCsv(objArray) {
            var array =
                typeof objArray != "object" ? JSON.parse(objArray) : objArray;

            var str = "";

            for (var i = 0; i < array.length; i++) {
                var line = "";
                for (var index in array[i]) {
                    if (line != "") line += ",";
                    line += array[i][index];
                }

                str += line + "\r\n";
            }

            return str;
        },
        exportCsvFile(headers, item, fileTitle) {
            var vm = this;
            if (headers) {
                item.unshift(headers);
            }
            var jsonObject = JSON.stringify(item);
            var csv = vm.convertToCsv(jsonObject);

            var exportedFilenmae = fileTitle + ".csv" || "export.csv";

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", exportedFilenmae);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        filterData() {
            this.initList(1);
        },
        resetFilter() {
            this.filter.search = "";
            this.filter.limit = 10;
            this.initList(1);
        },
        async initList(p) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
                status: 1,
            };
            if (this.filter.search) {
                pl["search"] = this.filter.search;
            }
            this.loading = true;
            const data = await this.getList(pl);
            this.loading = false;
            this.data.list = data.data;
            this.totalWingBand = data.total;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;
        },
        async exportData() {
            var current = new Date();
            var currentDate = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
            var headers = {
                stag_registry: "STAG REGISTRY NO.",
                breeder_name: "NAME OF BREEDERS",
                farm_name: "FARM NAME",
                farm_address: "FARM ADDRESS",
                province: "PROVINCE",
                wingband_no: "WINGBAND NO.",
                feather_color: "FEATHER COLOR",
                leg_color: "LEG COLOR",
                comb_shape: "COMB SHAPE",
                nose_markings: "NOSE MARKINGS",
                feet_markings: "FEET MARKINGS",
                date: "DATE",
            };
            var itemsFormatted = [];
            const arr = await this.data.list;
            arr.forEach((item) => {
                itemsFormatted.push({
                    stag_registry: item.stag_registry,
                    breeder_name: item.breeder_name,
                    farm_name: item.farm_name,
                    farm_address: item.farm_address,
                    province: item.province,
                    wingband_no: item.wingband_number,
                    feather_color: item.feather_color,
                    leg_color: item.leg_color,
                    comb_shape: item.comb_shape,
                    nose_markings: item.nose_markings,
                    feet_markings: item.feet_markings,
                    date: item.wingband_date,
                });
            });
            var fileTitle = `Wingbands ${currentDate}`;
            this.exportCsvFile(headers, itemsFormatted, fileTitle);
        },
        wingbandModal() {
            this.errorMessage = ""
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.importModal = false;
            this.importErrors = [];
            this.selectedFile = null;
        },
        goTo() {
            if (!this.wingband_data) {
                this.errorMessage = "Please enter a value before submitting.";
            } else {
                // $cookies.set("total_wingband", this.total_wingband)
                this.errorMessage = "";
                this.$router.push({
                    path: "/wingband",
                    query: { wingband_data: this.wingband_data },
                });
                this.showModal = false;
            }
        },
        async importExcel() {
            if (!this.selectedFile) {
                Swal.fire({
                    icon: "error",
                    title: "Failed!",
                    text: "Please select a file first.",
                });
                return;
            }

            if (this.isImporting) return;
            this.isImporting = true;
            this.importErrors = [];

            const formData = new FormData();
            formData.append("excel_file", this.selectedFile);
            try {
                const res = await this.importFile(formData);
                if (res.message === "Wingbands imported successfully please check the excel data uploaded to the system") {
                    Swal.fire({
                        icon: "success",
                        title: "Import successful! Wait for a few seconds to check.",
                        text: res.message,
                        timer: 4000,
                        timerProgressBar: true,
                    });
                    this.importModal = false;
                    this.initList();
                } else if (res.status === "error" && res.errors && res.errors.length > 0) {
                    this.importErrors = res.errors;
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed!",
                        text: res.message,
                    });
                }
            } catch (error) {
                console.error("Error uploading file:", error);
            } finally {
                this.isImporting = false;
            }
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
            } else {
                this.selectedFile = null;
            }
            console.log(this.selectedFile)
        },
        openImportModal() {
            this.importModal = true;
        },
        async downloadTemplate() {
            const link = document.createElement('a');
            link.href = '/Template.xlsx';
            link.download = 'Wingband_Import_Template.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async loadAdminDashboard() {
            const stats = await this.getDashboardStats();
            if (stats) {
                this.dashboardStats = stats;
            }
            const seasonData = await this.getSeasonCount({});
            if (seasonData && seasonData.data) {
                const entries = seasonData.data;
                var totalEntry = 0;
                entries.forEach(function(s) { totalEntry += (s.entry || 0); });
                var sc = this.seasonColors;
                var seasonMap = [
                    { label: 'Early Bird', color: sc.early_bird || '#6F42C1' },
                    { label: 'Local', color: sc.local || '#28A745' },
                    { label: 'National', color: sc.national || '#FFC107' },
                    { label: 'Late Born', color: sc.late_born || '#ADB5BD' },
                    { label: 'Genesis', color: sc.genesis || '#0DCAF0' },
                ];
                this.seasonChartData = entries.map(function(s, i) {
                    var entry = s.entry || 0;
                    var rawPercent = totalEntry > 0 ? (entry / totalEntry) * 100 : 0;
                    // Precise label: avoid rounding tiny shares (e.g. 277 of millions) down to 0%.
                    // Show more decimals the smaller the share is, so it never reads as "0%" when entries exist.
                    var percentLabel;
                    if (rawPercent === 0) {
                        percentLabel = "0";
                    } else if (rawPercent >= 1) {
                        percentLabel = (Math.round(rawPercent * 10) / 10).toString();
                    } else if (rawPercent >= 0.01) {
                        percentLabel = (Math.round(rawPercent * 100) / 100).toString();
                    } else {
                        // Smaller than 0.01% — show enough precision to stay non-zero.
                        percentLabel = rawPercent.toPrecision(2);
                    }
                    return {
                        label: seasonMap[i] ? seasonMap[i].label : 'Season ' + s.season,
                        color: seasonMap[i] ? seasonMap[i].color : '#999',
                        entry: entry,
                        // Bar width stays capped/rounded for layout; label carries the precise value.
                        percent: Math.round(rawPercent),
                        percentLabel: percentLabel,
                    };
                });
            }
        },
        async addArchive(id) {
            var pl = {
                id: id,
                status: 2,
            }
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "Do you want to archive this record?",
                type: "warning",
                showCancelButton: true,
                icon: "warning",
                padding: "2em",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {

                const res = await this.archive(pl);
                console.log(res);
                if (res.message == "Wingband archived successfully.") {
                    Swal.fire({
                        icon: "success",
                        title: "Add archive successful",
                        text: res.message,
                        timerProgressBar: true,
                        timer: 2000
                    });
                    this.initList()
                } else {
                    var error = res.message;
                    Swal.fire({
                        icon: "error",
                        title: "Failed!",
                        type: "error",
                        text: error,
                    });
                }
            }
        },
        getData(data) {
            this.edit_data.stag_registry = data.stag_registry;
            this.edit_data.breeder_name = data.breeder_name;
            this.edit_data.comb_shape = data.comb_shape;
            this.edit_data.created_by = data.created_by;
            this.edit_data.farm_address = data.farm_address;
            this.edit_data.farm_name = data.farm_name;
            this.edit_data.feather_color = data.feather_color;
            this.edit_data.feet_markings = data.feet_markings;
            this.edit_data.leg_color = data.leg_color;
            this.edit_data.nose_markings = data.nose_markings;
            this.edit_data.province = data.province;
            this.edit_data.season_name = data.season_name;
            this.edit_data.wingband_date = data.wingband_date;
            this.edit_data.wingband_number = data.wingband_number;
            if (data.status == 1) {
                this.edit_data.status = 'Pending';
            }
            console.log(data)
            this.edit_modal = true;
        },
        async editWingband(id) {
            var pl = {
                id: id,
                stag_registry: this.edit_data.stag_registry,
                breeder_name: this.edit_data.breeder_name,
                comb_shape: this.edit_data.comb_shape,
                created_by: this.edit_data.created_by,
                farm_address: this.edit_data.farm_address,
                farm_name: this.edit_data.farm_name,
                feather_color: this.edit_data.feather_color,
                feet_markings: this.edit_data.feet_markings,
                leg_color: this.edit_data.leg_color,
                nose_markings: this.edit_data.nose_markings,
                province: this.edit_data.province,
                season_name: this.edit_data.season_name,
                wingband_date: this.edit_data.wingband_date,
                wingband_number: this.edit_data.wingband_number,
            }
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "Do you want to edit this record?",
                type: "warning",
                showCancelButton: true,
                icon: "warning",
                padding: "2em",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {
                const res = await this.archive(pl);
                if (res.message == "Wingband updated successfully.") {
                    Swal.fire({
                        icon: "success",
                        title: "Add archive successful",
                        text: res.message,
                        timerProgressBar: true,
                        timer: 2000
                    });
                    this.initList()
                } else {
                    var error = res.message;
                    Swal.fire({
                        icon: "error",
                        title: "Failed!",
                        type: "error",
                        text: error,
                    });
                }
            }
        },
    },
    watch: {
        importModal(val) {
            if (!val) {
                this.importErrors = [];
                this.selectedFile = null;
                this.errorMessage = "";
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = "";
                }
            }
        }
    },
    mounted() {
        this.initList(1);
        if (this.profile.role === 'admin' || this.profile.role === 'viewer') {
            this.loadAdminDashboard();
        }
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body cust-padding">
                        <h3 class="mb-2 fw-bolder">User Information</h3>
                        <hr>
                        <div class="grid-2">
                            <div class="grid-2">
                                <div class="fw-bold">NAME:</div>
                                <div class="text-dark">{{ profile.username }}</div>
                            </div>
                            <div class="grid-2">
                                <div class="fw-bold">CONTACT #:</div>
                                <div class="text-dark">{{ profile.contact_number }}</div>
                            </div>
                            <div class="grid-2">
                                <div class="fw-bold">ROLE/TITLE:</div>
                                <div class="text-dark">
                                    <span v-if="profile.role == 'admin'">Admin</span>
                                    <span v-if="profile.role == 'encoder'">Encoder</span>
                                    <span v-if="profile.role == 'viewer'">Viewer</span>
                                </div>
                            </div>
                            <div class="grid-2">
                                <div class="fw-bold">REGISTRY DATE:</div>
                                <div class="text-dark">{{ dateTime(profile.created_at) }}</div>
                            </div>
                            <div class="grid-2" v-if="profile.role == 'encoder'">
                                <div class="fw-bold">TOTAL WINGBAND:</div>
                                <div class="text-dark">{{ totalWingBand ? totalWingBand : '-' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4" v-if="profile.role == 'encoder'">
                <div class="card disflex bg-green act-btn" @click="wingbandModal">
                    <p class="fw-bolder fs-2 text-white m-0 p-0">START WINGBANDING</p>
                </div>
            </div>
        </div>

        <!-- Dashboard Cards -->
        <div class="row" v-if="profile.role == 'admin' || profile.role == 'viewer'">
            <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Banded</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_banded || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-primary bg-opacity-10 p-3">
                            <i class="bx bx-bar-chart-alt-2 text-primary fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Chapters</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_chapters || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-success bg-opacity-10 p-3">
                            <i class="bx bx-map text-success fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Farms</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_farms || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-warning bg-opacity-10 p-3">
                            <i class="bx bx-home-alt text-warning fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Stag Registry</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_stag_registry || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-info bg-opacity-10 p-3">
                            <i class="bx bx-id-card text-info fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Breeders</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_breeders || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-secondary bg-opacity-10 p-3">
                            <i class="bx bx-user text-secondary fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6" v-if="profile.role == 'admin'">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Admin Users</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_admin_users || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-danger bg-opacity-10 p-3">
                            <i class="bx bx-shield text-danger fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6" v-if="profile.role == 'admin'">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Encoder Users</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_encoder_users || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-success bg-opacity-10 p-3">
                            <i class="bx bx-edit text-success fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6" v-if="profile.role == 'admin'">
                <div class="card mini-stats-wid">
                    <div class="card-body d-flex align-items-center">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-1">Total Viewer Users</p>
                            <h4 class="mb-0">{{ (dashboardStats.total_viewer_users || 0).toLocaleString() }}</h4>
                        </div>
                        <div class="mini-stat-icon rounded-circle bg-info bg-opacity-10 p-3">
                            <i class="bx bx-show text-info fs-4"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Banding Growth by Season -->
        <div class="row" v-if="profile.role == 'admin' || profile.role == 'viewer'">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title mb-3"><i class="bx bx-trending-up me-1"></i> Banding Growth by Season</h5>
                        <div class="season-chart">
                            <div class="season-chart-row" v-for="season in seasonChartData" :key="season.label">
                                <div class="season-chart-label">{{ season.label }}</div>
                                <div class="season-chart-bar-wrapper">
                                    <div class="season-chart-bar" :style="{ width: season.percent + '%', backgroundColor: season.color }">
                                        <span class="season-chart-value" v-if="season.entry > 0 && season.percent >= 8">{{ season.percentLabel }}%</span>
                                    </div>
                                    <span class="season-chart-value-outside" v-if="season.entry > 0 && season.percent < 8">{{ season.percentLabel }}%</span>
                                </div>
                                <div class="season-chart-total">{{ season.entry.toLocaleString() }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="profile.role != 'admin' && profile.role != 'viewer'">
            <div class="col-lg-12">
                <div class="card p-0">
                    <div class="d-flex flex-wrap px-3 pt-2 gap-2">
                        <div class="col-12 col-md-6">
                            <div class="d-flex align-items-end h-100">
                                <div class="d-flex flex-wrap align-items-center gap-2 custom-border p-1 w-100">
                                    <label class="filter-label">Search:</label>
                                    <input class="form-control" style="min-width:120px;flex:1;" type="text" v-model="filter.search"
                                        placeholder="Search...">
                                    <button class="btn btn-success apply-filt-width" data-toggle="tooltip"
                                        data-placement="top" title="Apply" @click="filterData()">Search</button>
                                    <button class="btn btn-secondary ms-2" @click="resetFilter()">Reset</button>
                                    <label class="filter-label">Limit:</label>
                                    <select class="form-control" style="width:80px;" v-model="filter.limit" @change="filterData()">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                        <option value="500">500</option>
                                        <option value="1000">1000</option>
                                        <option value="5000">5000</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-end">
                            <button class="btn btn-light disflex" @click="exportData()" data-toggle="tooltip"
                                v-if="profile.role != 'encoder'" data-placement="top" title="Export"><i
                                    class='bx bx-export fs-4'></i> <span class="mt-1 ms-1">Export</span>
                            </button>
                            <button class="btn btn-primary disflex me-2" @click="downloadTemplate()" data-toggle="tooltip"
                                v-if="profile.role == 'encoder'" data-placement="bottom" title="Download Import Template"><i
                                    class='bx bx-download fs-4'></i> <span class="mt-1 ms-1">Import Template</span>
                            </button>
                            <button class="btn btn-success disflex" @click="openImportModal()" data-toggle="tooltip"
                                v-if="profile.role == 'encoder'" data-placement="top" title="Import"><i
                                    class='bx bx-export fs-4'></i> <span class="mt-1 ms-1">Import</span>
                            </button>                        </div>
                    </div>
                    <div class="pt-3 custom-overflow">
                        <table class="mb-0 table">
                            <thead>
                                <tr class="bg-light">
                                    <th>Stag Registry No.</th>
                                    <th>Name of Breeders</th>
                                    <th>Farm Name</th>
                                    <th>Farm Address</th>
                                    <th>Province</th>
                                    <th>Chapter</th>
                                    <th>Contact No.</th>
                                    <th>Wingband No.</th>
                                    <th>Feather Color</th>
                                    <th>Leg Color</th>
                                    <th>Comb Shape</th>
                                    <th>Nose Markings</th>
                                    <th>Feet Markings</th>
                                    <th>Date</th>
                                    <th>Season</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="(data, index) in data.list" :key="index">
                                    <td>{{ data.stag_registry }}</td>
                                    <td>{{ data.breeder_name }}</td>
                                    <td>{{ data.farm_name }}</td>
                                    <td>{{ data.farm_address }}</td>
                                    <td>{{ data.province }}</td>
                                    <td>{{ data.chapter }}</td>
                                    <td>{{ data.contact_number }}</td>
                                    <td>{{ data.wingband_number }}</td>
                                    <td>{{ data.feather_color }}</td>
                                    <td>{{ data.leg_color }}</td>
                                    <td>{{ data.comb_shape }}</td>
                                    <td>{{ data.nose_markings }}</td>
                                    <td>{{ data.feet_markings }}</td>
                                    <td>{{ data.wingband_date }}</td>
                                    <td>{{ data.season_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="fetching-data" v-if="this.data.list == null || this.data.list == ''">
                            <h1 class="p-3">Fetching wingbands...</h1>
                        </div> -->
                        <div v-if="loading" class="loader">Loading...</div>
                    </div>
                    <Pagination :data="data" @emitPage="initList" class="me-2" />
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-3">
            <div class="my-4 text-center">
                <b-modal v-model="showModal" id="modal-standard" centered title="Wingband" title-class="font-18"
                    hide-footer>
                    <div>
                        <div>
                            <label class="mt-2 mb-2">Total Wingband:</label>
                            <input class="form-control w-100" type="number" v-model="this.wingband_data"
                                placeholder="Enter total of wingband...">
                            <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
                        </div>
                    </div>
                    <div class="modal-footer mt-3 pb-0">
                        <div class="d-flex justify-content-end align-items-center w-100">
                            <button class="btn btn-secondary text-white mx-1" @click="closeModal()">Cancel</button>
                            <button class="btn btn-success text-white mx-1" @click="goTo()">Submit</button>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-3">
            <div class="my-4 text-center">
                <b-modal v-model="importModal" id="modal-standard" centered title="Import Wingband"
                    title-class="font-18" hide-footer size="xl">
                    <div>
                        <div>
                            <label class="mt-2 mb-2">Select File:</label>
                            <input class="form-control w-100" type="file" @change="handleFileUpload" accept=".xls,.xlsx"
                                ref="fileInput"
                                placeholder="Enter total of wingband...">
                            <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
                        </div>

                        <div v-if="importErrors.length > 0" class="mt-3">
                            <div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
                                <i class="bx bx-error-circle fs-5 me-2"></i>
                                <div>
                                    <strong>Import Failed.</strong> The uploaded file contains invalid data. Please correct the errors below and re-upload.
                                </div>
                            </div>
                            <div class="table-responsive" style="max-height: 350px; overflow-y: auto;">
                                <table class="table table-bordered table-sm mb-0">
                                    <thead class="table-danger" style="position: sticky; top: 0; z-index: 1;">
                                        <tr>
                                            <th class="text-center" style="width: 60px;">Row</th>
                                            <th style="width: 140px;">Column</th>
                                            <th style="width: 120px;">Value</th>
                                            <th>Error</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(err, i) in importErrors" :key="i">
                                            <td class="text-center fw-bold text-danger">{{ err.row }}</td>
                                            <td class="fw-semibold">{{ err.column }}</td>
                                            <td>
                                                <span class="badge bg-secondary">{{ err.value }}</span>
                                            </td>
                                            <td class="text-danger small">{{ err.message }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3 pb-0">
                        <div class="d-flex justify-content-end align-items-center w-100">
                            <button class="btn btn-secondary text-white mx-1" @click="closeModal()">Cancel</button>
                            <button class="btn btn-success text-white mx-1" :disabled="isImporting" @click="importExcel()">
                                <span v-if="isImporting">Importing...</span>
                                <span v-else>Import Excel</span>
                            </button>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
        <!-- MODALS -->
        <b-modal v-model="edit_modal" id="modal-standard" size="xl" centered title="Edit Wingband" title-class="font-18"
            hide-footer>
            <div class="row mb-3">
                <div class="col-3">
                    <label class="mt-2 mb-2">Stag Registry No:</label>
                    <input class="form-control w-100" v-model="edit_data.stag_registry">
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-3">
                    <label class="mt-2 mb-2">Date:</label>
                    <input class="form-control w-100" disabled type="date" v-model="edit_data.wingband_date">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Status:</label>
                    <input class="form-control w-100 " disabled v-model="edit_data.status">
                </div>
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-4">
                    <label class="mt-2 mb-2">Farm name:</label>
                    <input class="form-control w-100" v-model="edit_data.farm_name">
                </div>
                <div class="col-4">
                    <label class="mt-2 mb-2">Farm address:</label>
                    <input class="form-control w-100" v-model="edit_data.farm_address">
                </div>
                <div class="col-4">
                    <label class="mt-2 mb-2">Province:</label>
                    <input class="form-control w-100" v-model="edit_data.province">
                </div>
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-3">
                    <label class="mt-2 mb-2">Name of Breeder:</label>
                    <input class="form-control w-100" v-model="edit_data.breeder_name">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Wingband No:</label>
                    <input class="form-control w-100" v-model="edit_data.wingband_number">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Chapter:</label>
                    <input class="form-control w-100" v-model="edit_data.chapter">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Contact number</label>
                    <input class="form-control w-100" v-model="edit_data.contact_number">
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-3">
                    <label class="mt-2 mb-2">Feather color:</label>
                    <input class="form-control w-100" v-model="edit_data.feather_color">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Leg color:</label>
                    <input class="form-control w-100" v-model="edit_data.leg_color">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Comb shape:</label>
                    <input class="form-control w-100" v-model="edit_data.comb_shape">
                </div>
                <div class="col-3">
                    <label class="mt-2 mb-2">Nose markings:</label>
                    <input class="form-control w-100" v-model="edit_data.nose_markings">
                </div>
            </div>
            <div class="mt-3 pb-0">
                <div class="d-flex justify-content-end align-items-center w-100">
                    <button class="btn btn-success text-white mx-1" @click="editWingband()">Submit</button>
                    <button class="btn btn-danger text-white mx-1" @click="edit_modal = false">Cancel</button>
                </div>
            </div>
        </b-modal>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
}

th {
    text-transform: uppercase;
}

.season-chart-row {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}

.season-chart-label {
    width: 100px;
    font-weight: 600;
    font-size: 13px;
    flex-shrink: 0;
}

.season-chart-bar-wrapper {
    flex: 1;
    background-color: #f1f3f4;
    border-radius: 4px;
    height: 22px;
    margin: 0 12px;
    position: relative;
    display: flex;
    align-items: center;
}

.season-chart-bar {
    height: 100%;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: width 0.6s ease;
    min-width: 2px;
    flex-shrink: 0;
    overflow: hidden;
}

.season-chart-value {
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
}

.season-chart-value-outside {
    color: #495057;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
    margin-left: 6px;
}

.season-chart-total {
    width: 60px;
    text-align: right;
    font-weight: 700;
    font-size: 13px;
    flex-shrink: 0;
}

.mini-stats-wid {
    border-left: 3px solid transparent;
}

.mini-stats-wid:nth-child(1) { border-left-color: #556ee6; }
.mini-stats-wid:nth-child(2) { border-left-color: #34c38f; }
.mini-stats-wid:nth-child(3) { border-left-color: #f1b44c; }
.mini-stats-wid:nth-child(4) { border-left-color: #50a5f1; }
.mini-stats-wid:nth-child(5) { border-left-color: #74788d; }
.mini-stats-wid:nth-child(6) { border-left-color: #f46a6a; }
</style>